module.exports = __webpack_public_path__ + "img/audio.8f8f3d19.svg";